import React, { useEffect } from 'react';
import {
  LoaderFunctionArgs,
  Outlet,
  useLocation,
  useParams,
} from 'react-router';

import AdultToggle from '~/components/AdultToggle';
import Loading from '~/components/Loading';

import { useAuth } from '~/modules/auth/useAuth';
import { fetchUser, getUserByName } from '~/modules/user';

import { useAppDispatch, useAppSelector } from '~/hooks/redux';

import styles from './$username.scss';
import FolderSet from './_components/FolderSet';
import GalleryPageHeader from './_components/GalleryPageHeader';
import GalleryTabs from './_components/GalleryTabs';

export default function UserGalleryLayout() {
  const { isSignedIn, currentUser } = useAuth();
  const { username } = useParams();
  const { pathname } = useLocation();

  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => getUserByName(state, username));

  useEffect(() => {
    // @ts-expect-error
    if (username && !user) dispatch(fetchUser(username));
  }, [username]);

  if (!user) return <Loading />;

  return (
    <div className={styles.GalleryPage}>
      <GalleryPageHeader
        {...{
          isSignedIn,
          currentUser,
          user,
        }}
      />

      <AdultToggle />

      <GalleryTabs username={user.username} />

      {!pathname.endsWith('favorites') && (
        <FolderSet
          user={user}
          showActions={
            currentUser &&
            (currentUser.role === 'admin' ||
              user.username === currentUser.username)
          }
          actions={{
            // @ts-expect-error
            deleteFolder: (id) => dispatch(deleteFolder(id)),
            protectFolder: (id, password) =>
              // @ts-expect-error
              dispatch(updateFolder(id, { password })),
          }}
        />
      )}

      <Outlet context={{ user }} />
    </div>
  );
}

export const loader =
  (store) =>
  async ({ params: { username } }: LoaderFunctionArgs) => {
    await store.dispatch(fetchUser(username));
    return {};
  };
